import { render, staticRenderFns } from "./plan-details.vue?vue&type=template&id=5beeaa66&"
import script from "./plan-details.vue?vue&type=script&lang=js&"
export * from "./plan-details.vue?vue&type=script&lang=js&"
import style0 from "./plan-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports